import React from 'react'
import { Form, Formik } from 'formik'
import { required } from '../../utils/validators'
import Input from '../../components/common/Input'
import Button from '../../components/common/Button'
import Select from '../../components/common/Select'

export default function EmployeeForm({ onCancel, onSubmit, initialValues, loading }) {
    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                name: '',
                salaryType: '',
                dailyRate: '',
                monthlySalary: '',
                isActive: '',
                phone: '',
                position: '',
                ...initialValues,
            }}
        >
            {({ values }) => (
                <Form>
                    <Input name="name" label="Ходим исми" validate={required} />
                    <Select
                        empty
                        options={[
                            { value: 'monthly', name: 'Ойлик' },
                            { value: 'daily', name: 'Кунлик' },
                        ]}
                        optionValue="value"
                        optionLabel="name"
                        name="salaryType"
                        label="Иш ҳақи тури"
                        validate={required}
                    />
                    {values.salaryType === 'daily' && <Input name="dailyRate" label="Кунлик ставка" />}
                    {values.salaryType === 'monthly' && <Input name="monthlySalary" label="Ойлик маош" />}
                    <Select
                        empty
                        options={[
                            { value: true, name: 'Фаол' },
                            { value: false, name: 'Фаол эмас' },
                        ]}
                        optionValue="value"
                        optionLabel="name"
                        name="isActive"
                        label="Фаол ҳолати"
                        validate={required}
                    />
                    <Input name="phone" label="Телефон рақами" validate={required} />
                    <Input name="position" label="Лавозим" validate={required} />

                    <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                        <div className="button-wrapper">
                            <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                        </div>
                        <div className="button-wrapper">
                            <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}
